import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { IonicModule } from '@ionic/angular';
import { GuageModule } from 'src/app/controls/guage/guage.module';
import { TranslatePipe, TranslateDirective } from '@ngx-translate/core';
import { IQConnectEmulatorComponent } from './iq-connect-emulator.component';



@NgModule({
  declarations: [IQConnectEmulatorComponent],
  imports: [
    CommonModule,
    IonicModule,
    GuageModule,
    TranslatePipe, TranslateDirective
  ],
  exports:[
    IQConnectEmulatorComponent
  ]
})
export class IQConnectEmulatorModule { }



